import * as i0 from '@angular/core';
import { EventEmitter, Directive, Output, HostListener, Pipe, Component, Input, NgModule, Injectable } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i2$1 from 'primeng/blockui';
import { BlockUIModule } from 'primeng/blockui';
import * as i3$1 from 'primeng/progressspinner';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import moment from 'moment';
import * as i1 from '@angular/platform-browser';
import { timer, throwError } from 'rxjs';
import * as i3 from '@caloptima/portal-foundation';
import { SessionTimerSitecoreTemplate } from '@caloptima/portal-foundation';
import * as i1$2 from 'angular-oauth2-oidc';
import { OAuthService } from 'angular-oauth2-oidc';
import * as i4 from '@auth0/angular-jwt';
import { catchError } from 'rxjs/operators';
import { AuthHelper } from '@caloptima/authentication';
function EmailComponent_div_0_div_14_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r5.validationMessages.RequiredMessage || "email is required.");
  }
}
function EmailComponent_div_0_div_14_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.validationMessages.MaxLengthMessage || "email has exceeded the number of characters allowed.");
  }
}
function EmailComponent_div_0_div_14_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.validationMessages.InvalidInputMessage || "email is invalid.");
  }
}
function EmailComponent_div_0_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, EmailComponent_div_0_div_14_div_1_Template, 3, 1, "div", 1)(2, EmailComponent_div_0_div_14_div_2_Template, 3, 1, "div", 1)(3, EmailComponent_div_0_div_14_div_3_Template, 3, 1, "div", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(13);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", _r3.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", _r3.errors.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", _r3.errors.pattern);
  }
}
const _c0 = a0 => ({
  "has-error has-feedback": a0
});
function EmailComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "form", null, 3)(3, "fieldset")(4, "div", 4)(5, "h4");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 5)(8, "div", 4)(9, "label", 6);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 7)(12, "input", 8, 9);
    i0.ɵɵtwoWayListener("ngModelChange", function EmailComponent_div_0_Template_input_ngModelChange_12_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r8.emailText, $event) || (ctx_r8.emailText = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(14, EmailComponent_div_0_div_14_Template, 4, 3, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 11)(16, "div", 12)(17, "button", 13);
    i0.ɵɵlistener("click", function EmailComponent_div_0_Template_button_click_17_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.resetView());
    });
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "button", 14);
    i0.ɵɵlistener("click", function EmailComponent_div_0_Template_button_click_19_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.updateEmail());
    });
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const _r2 = i0.ɵɵreference(2);
    const _r3 = i0.ɵɵreference(13);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.viewProperties.Title || "your email address is");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.viewProperties.FieldLabel || "email address");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0, (_r3 == null ? null : _r3.value) != null && _r3.errors && _r3.touched && _r3.dirty));
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.emailText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r3 && _r3.errors && _r3.touched && _r3.dirty);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.viewProperties.CancelButtonText || "cancel");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !_r2.form.valid || !_r3.dirty || ctx_r0.emailText == ctx_r0.oldValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.viewProperties.SubmitButtonText || "update");
  }
}
function EmailComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "h4", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16)(4, "label", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.viewProperties.Title || "your email address is");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.viewProperties.FieldLabel || "email address");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.emailText);
  }
}
function WaitCursorComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "p-blockUI", 2);
    i0.ɵɵelement(2, "p-progressSpinner", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("blocked", ctx_r0.show);
  }
}
let PhoneMaskDirective = /*#__PURE__*/(() => {
  class PhoneMaskDirective {
    constructor(model, el) {
      this.model = model;
      this.el = el;
      this.ngModelChange = new EventEmitter();
      this.regex = new RegExp(/-?[0-9]$/g);
      // Allow key codes for special events. Reflect :
      // Backspace, tab, end, home
      this.specialKeys = ['Backspace', 'Tab', 'End', 'Home', '-', 'Delete'];
    }
    onInputChange($event, backspace = false) {
      // remove all mask characters (keep only numeric)
      this.value = $event.target.value.replace(/\D/g, '');
      // special handling of backspace necessary otherwise
      // deleting of non-numeric characters is not recognized
      // this laves room for improvement for example if you delete in the
      // middle of the string
      if (backspace) {
        this.value = this.value.replace(0, this.value.length - 1);
      }
      // don't show braces for empty value
      if (this.value.length == 0) {
        this.value = '';
      }
      // don't show braces for empty groups at the end
      else if (this.value.length <= 3) {
        this.value = this.value.replace(/^(\d{0,3})/, '$1');
      } else if (this.value.length <= 6) {
        this.value = this.value.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else {
        this.value = this.value.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1-$2-$3');
      }
      this.ngModelChange.emit(this.value);
      // set the new value
    }
    onKeyDown(event) {
      // Allow Backspace, tab, end, and home keys
      if (this.specialKeys.indexOf(event.key) !== -1) {
        return;
      }
      const current = this.el.nativeElement.textContent;
      const next = current.concat(event.key);
      if (next && !String(next).match(this.regex)) {
        event.preventDefault();
      }
    }
    static {
      this.ɵfac = function PhoneMaskDirective_Factory(t) {
        return new (t || PhoneMaskDirective)(i0.ɵɵdirectiveInject(i2.NgControl), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: PhoneMaskDirective,
        selectors: [["", "phone", ""]],
        hostBindings: function PhoneMaskDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function PhoneMaskDirective_input_HostBindingHandler($event) {
              return ctx.onInputChange($event);
            })("keydown", function PhoneMaskDirective_keydown_HostBindingHandler($event) {
              return ctx.onKeyDown($event);
            });
          }
        },
        outputs: {
          ngModelChange: "ngModelChange"
        }
      });
    }
  }
  return PhoneMaskDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UppercaseInputDirective = /*#__PURE__*/(() => {
  class UppercaseInputDirective {
    constructor() {
      this.ngModelChange = new EventEmitter();
    }
    onInputChange($event) {
      this.value = $event.target.value.toUpperCase();
      this.ngModelChange.emit(this.value);
    }
    static {
      this.ɵfac = function UppercaseInputDirective_Factory(t) {
        return new (t || UppercaseInputDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: UppercaseInputDirective,
        selectors: [["", "ngModel", "", "uppercaseInput", ""]],
        hostBindings: function UppercaseInputDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function UppercaseInputDirective_input_HostBindingHandler($event) {
              return ctx.onInputChange($event);
            });
          }
        },
        outputs: {
          ngModelChange: "ngModelChange"
        }
      });
    }
  }
  return UppercaseInputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZipCodeMaskDirective = /*#__PURE__*/(() => {
  class ZipCodeMaskDirective {
    constructor(model) {
      this.model = model;
      this.ngModelChange = new EventEmitter();
    }
    onInputChange($event, backspace = false) {
      // remove all mask characters (keep only numeric)
      if ($event.target.value) {
        this.value = $event.target.value.replace(/\D/g, '');
        // special handling of backspace necessary otherwise
        // deleting of non-numeric characters is not recognized
        // this laves room for improvement for example if you delete in the 
        // middle of the string
        if (backspace) {
          this.value = this.value.replace(0, this.value.length - 1);
        }
        // don't show braces for empty value
        if (this.value.length == 0) {
          this.value = '';
        }
        // don't show braces for empty groups at the end
        if (this.value.length > 5) {
          this.value = this.value.replace(/^(\d{0,5})(\d{0,4})/, '$1-$2');
        }
      }
      this.ngModelChange.emit(this.value);
      // set the new value
      //this.model.valueAccessor.writeValue(newVal);
    }
    static {
      this.ɵfac = function ZipCodeMaskDirective_Factory(t) {
        return new (t || ZipCodeMaskDirective)(i0.ɵɵdirectiveInject(i2.NgControl));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ZipCodeMaskDirective,
        selectors: [["", "ngModel", "", "zipcode", ""]],
        hostBindings: function ZipCodeMaskDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function ZipCodeMaskDirective_input_HostBindingHandler($event) {
              return ctx.onInputChange($event);
            });
          }
        },
        outputs: {
          ngModelChange: "ngModelChange"
        }
      });
    }
  }
  return ZipCodeMaskDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CommaSeparatedNumberPipe = /*#__PURE__*/(() => {
  class CommaSeparatedNumberPipe {
    transform(value, args) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    static {
      this.ɵfac = function CommaSeparatedNumberPipe_Factory(t) {
        return new (t || CommaSeparatedNumberPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "commaSeparated",
        type: CommaSeparatedNumberPipe,
        pure: true
      });
    }
  }
  return CommaSeparatedNumberPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DateFormatPipe = /*#__PURE__*/(() => {
  class DateFormatPipe {
    transform(value, args) {
      return moment(value).format(args);
    }
    static {
      this.ɵfac = function DateFormatPipe_Factory(t) {
        return new (t || DateFormatPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dateFormat",
        type: DateFormatPipe,
        pure: true
      });
    }
  }
  return DateFormatPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZipCodePipe = /*#__PURE__*/(() => {
  class ZipCodePipe {
    transform(val) {
      //val = val.charAt(0) != 0 ? '0' + val : '' + val;
      if (val != undefined && val != null) {
        let newStr = val;
        let i = 0;
        if (val && val.length > 5 && val.indexOf('-') < 0) {
          newStr = val.substr(0, 5) + '-' + val.substr(5, 9);
        } else {
          newStr = val;
        }
        return newStr;
      } else {
        return '';
      }
    }
    static {
      this.ɵfac = function ZipCodePipe_Factory(t) {
        return new (t || ZipCodePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "zipcode",
        type: ZipCodePipe,
        pure: true
      });
    }
  }
  return ZipCodePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormatAddressPipe = /*#__PURE__*/(() => {
  class FormatAddressPipe {
    transform(obj, delimiter) {
      if (obj == null) return null;
      let output = "",
        zipCode = "";
      if (!delimiter) delimiter = " ";
      let zipPipe = new ZipCodePipe();
      if (obj.zipCode) {
        zipCode = zipPipe.transform(obj.zipCode);
      }
      output = (obj.address1 + " " + obj.address2).trim() + delimiter + obj.city + delimiter + obj.state + delimiter + zipCode;
      return output;
    }
    static {
      this.ɵfac = function FormatAddressPipe_Factory(t) {
        return new (t || FormatAddressPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "formatAddress",
        type: FormatAddressPipe,
        pure: true
      });
    }
  }
  return FormatAddressPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PhonePipe = /*#__PURE__*/(() => {
  class PhonePipe {
    transform(val, args) {
      //val = val.charAt(0) != 0 ? '0' + val : '' + val;
      var newStr = "";
      if (val != null) {
        val = val.trim();
        if (val.length >= 10) {
          if (val.includes("-")) {
            newStr = val;
          } else {
            newStr = val.substr(0, 3) + '-' + val.substr(3, 3) + '-' + val.substr(6, 4);
          }
        }
      }
      return newStr;
    }
    static {
      this.ɵfac = function PhonePipe_Factory(t) {
        return new (t || PhonePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "phone",
        type: PhonePipe,
        pure: true
      });
    }
  }
  return PhonePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SafePipe = /*#__PURE__*/(() => {
  class SafePipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    static {
      this.ɵfac = function SafePipe_Factory(t) {
        return new (t || SafePipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "safe",
        type: SafePipe,
        pure: true
      });
    }
  }
  return SafePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// truncate.ts
let TruncatePipe = /*#__PURE__*/(() => {
  class TruncatePipe {
    transform(value, strLength, suffix) {
      if (value) {
        let limit = strLength ? strLength : '10';
        let trail = suffix ? suffix : '...';
        let ln = parseInt(limit);
        return value.length > ln ? value.substring(0, ln) + trail : value;
      } else {
        return '';
      }
    }
    static {
      this.ɵfac = function TruncatePipe_Factory(t) {
        return new (t || TruncatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "truncate",
        type: TruncatePipe,
        pure: true
      });
    }
  }
  return TruncatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class EmailViewProperties {}
class EmailValidationMessages {}
let EmailComponent = /*#__PURE__*/(() => {
  class EmailComponent {
    constructor() {
      this.viewProperties = new EmailViewProperties();
      this.validationMessages = new EmailValidationMessages();
      this.onEmailUpdated = new EventEmitter();
    }
    ngOnInit() {}
    set emailValue(emailValue) {
      this.emailText = emailValue;
      this.oldValue = emailValue;
    }
    resetView() {
      this.emailText = this.oldValue;
    }
    updateEmail() {
      this.onEmailUpdated.emit(this.emailText);
    }
    static {
      this.ɵfac = function EmailComponent_Factory(t) {
        return new (t || EmailComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EmailComponent,
        selectors: [["app-email"]],
        inputs: {
          viewProperties: "viewProperties",
          validationMessages: "validationMessages",
          emailValue: "emailValue"
        },
        outputs: {
          onEmailUpdated: "onEmailUpdated"
        },
        decls: 2,
        vars: 2,
        consts: [["class", "email-phone-fixed-box", 4, "ngIf"], [4, "ngIf"], [1, "email-phone-fixed-box"], ["emailForm", "ngForm"], [1, "email-phone-fixed-title"], [1, "form-group"], ["for", "email", 1, "control-label"], [3, "ngClass"], ["id", "email", "name", "email", "type", "email", "maxlength", "512", "pattern", "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["email", "ngModel"], ["class", "has-error", 4, "ngIf"], [1, "row", "email-phone-fixed-footer"], [1, "col-md-12", "text-right"], [1, "btn", "btn-link", 3, "click"], ["type", "submit", 1, "btn", "btn-primary", 3, "disabled", "click"], [1, "has-error"], [1, "email-info-box"]],
        template: function EmailComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, EmailComponent_div_0_Template, 21, 10, "div", 0)(1, EmailComponent_div_1_Template, 8, 3, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.viewProperties.ReadOnly);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.viewProperties.ReadOnly);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgIf, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.MaxLengthValidator, i2.PatternValidator, i2.NgModel, i2.NgForm],
        encapsulation: 2
      });
    }
  }
  return EmailComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class UIConfig {
  constructor(uiConfig) {
    this.uiConfig = uiConfig;
    this.uiConfig.subscribe(() => {
      this.SessionStateKey = this.uiConfig.getConfig('SessionStateKey');
      this.SessionTimeOutUrl = this.uiConfig.getConfig('SessionTimeOutUrl');
      this.SessionTimerContentServiceParameter = this.uiConfig.getConfig('SessionTimerContentServiceParameter');
      this.TimeToShowSessionTimerBeforeSessionExpires = this.uiConfig.getConfig('TimeToShowSessionTimerBeforeSessionExpires');
      this.SecondsPrefix = this.uiConfig.getConfig('SecondsPrefix');
      this.SecondsLabel = this.uiConfig.getConfig('SecondsLabel');
      this.MinutesPrefix = this.uiConfig.getConfig('MinutesPrefix');
      this.MinutesLabel = this.uiConfig.getConfig('MinutesLabel');
      this.TimerColon = this.uiConfig.getConfig('TimerColon');
      this.SessionTimerModalId = this.uiConfig.getConfig('SessionTimerModalId');
      this.FirstSessionTimeout = this.uiConfig.getConfig('FirstSessionTimeout');
      this.SecondSessionTimeout = this.uiConfig.getConfig('SecondSessionTimeout');
      this.FiftyNineSecondsInMillisSeconds = this.uiConfig.getConfig('FiftyNineSecondsInMillisSeconds');
      this.SixtySecondsInMilliSeconds = this.uiConfig.getConfig('SixtySecondsInMilliSeconds');
      this.OneSecondInMilliSeconds = this.uiConfig.getConfig('OneSecondInMilliSeconds');
      this.TenMinutes = this.uiConfig.getConfig('TenMinutes');
      this.TenSeconds = this.uiConfig.getConfig('TenSeconds');
      this.SpaceString = this.uiConfig.getConfig('SpaceString');
    });
  }
}
let SessionTimerComponent = /*#__PURE__*/(() => {
  class SessionTimerComponent {
    constructor(authService, configuration, sessionTimerSitecoreService, jwtHelper) {
      this.authService = authService;
      this.configuration = configuration;
      this.sessionTimerSitecoreService = sessionTimerSitecoreService;
      this.jwtHelper = jwtHelper;
      this.message = "";
      this.showSessionExpiryDialogue = false;
      this.checkTimeLeftForTimeout = true;
      this.timerRefreshInterval = this.configuration.FirstSessionTimeout;
      this.sessionTimerSitecoreContent = new SessionTimerSitecoreTemplate();
    }
    ngOnInit() {
      try {
        if (!this.jwtHelper.isTokenExpired) {
          this.sessionTimerSitecoreService.getSessionTimerSitecoreContent().subscribe(response => {
            this.sessionTimerSitecoreContent = response;
          }, error => this.message = error);
        }
      } catch (ex) {
        throw ex;
      }
    }
    getTimeLeftForSessionToExpire() {
      var token = this.authService.getAccessToken();
      if (!this.jwtHelper.isTokenExpired(token)) {
        let timeLeftForexpiration;
        timeLeftForexpiration = this.jwtHelper.getTokenExpirationDate(token).getTime() - Date.now();
        if (timeLeftForexpiration <= this.configuration.TimeToShowSessionTimerBeforeSessionExpires) {
          this.timerRefreshInterval = this.configuration.SecondSessionTimeout;
          if (!this.showSessionExpiryDialogue) {
            this.showSessionExpiryDialogue = true;
            this.showSessionTimeoutDialog();
          }
          return this.formatTimeLeftForSesssionToExpire(timeLeftForexpiration);
        }
      } else {
        this.logOut();
      }
    }
    logOut() {
      this.authService.logOut();
      sessionStorage.removeItem(this.configuration.SessionStateKey);
      window.location.href = this.configuration.SessionTimeOutUrl;
    }
    showSessionTimeoutDialog() {
      $(this.configuration.SessionTimerModalId).modal({
        show: this.showSessionExpiryDialogue
      });
    }
    unsubscibeFromTimer() {
      this.checkTimeLeftForTimeout = false;
    }
    refreshObservable() {
      return timer(this.timerRefreshInterval);
    }
    formatTimeLeftForSesssionToExpire(timeLeftForExpiration) {
      var minutesLeftForExpiration;
      var secondsLeftForExpiration;
      secondsLeftForExpiration = this.formatSecondsLeftForSessionToExpire(timeLeftForExpiration);
      if (timeLeftForExpiration > this.configuration.FiftyNineSecondsInMillisSeconds) {
        minutesLeftForExpiration = this.formatMinutesLeftForSessionToExpire(timeLeftForExpiration);
        return minutesLeftForExpiration + this.configuration.TimerColon + secondsLeftForExpiration + this.configuration.SpaceString + this.configuration.MinutesLabel;
      } else {
        return this.configuration.SecondsPrefix + secondsLeftForExpiration + this.configuration.SpaceString + this.configuration.SecondsLabel;
      }
    }
    formatMinutesLeftForSessionToExpire(timeLeftForExpiration) {
      var minutesLeftForExpiration;
      minutesLeftForExpiration = Math.floor(timeLeftForExpiration / this.configuration.SixtySecondsInMilliSeconds);
      if (minutesLeftForExpiration < this.configuration.TenMinutes) minutesLeftForExpiration = this.configuration.MinutesPrefix + minutesLeftForExpiration;
      return minutesLeftForExpiration;
    }
    formatSecondsLeftForSessionToExpire(timeLeftForExpiration) {
      var secondsLeftForExpiration;
      if (timeLeftForExpiration > this.configuration.FiftyNineSecondsInMillisSeconds) {
        secondsLeftForExpiration = Math.round(timeLeftForExpiration % this.configuration.SixtySecondsInMilliSeconds / this.configuration.OneSecondInMilliSeconds);
      } else {
        secondsLeftForExpiration = Math.round(timeLeftForExpiration / this.configuration.OneSecondInMilliSeconds);
      }
      if (secondsLeftForExpiration < this.configuration.TenSeconds) secondsLeftForExpiration = this.configuration.MinutesPrefix + secondsLeftForExpiration;
      return secondsLeftForExpiration;
    }
    static {
      this.ɵfac = function SessionTimerComponent_Factory(t) {
        return new (t || SessionTimerComponent)(i0.ɵɵdirectiveInject(i1$2.OAuthService), i0.ɵɵdirectiveInject(UIConfig), i0.ɵɵdirectiveInject(i3.SessionTimerSitecoreService), i0.ɵɵdirectiveInject(i4.JwtHelperService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SessionTimerComponent,
        selectors: [["session-timer"]],
        inputs: {
          timeLeftForSessionToExpireInput: "timeLeftForSessionToExpireInput"
        },
        decls: 14,
        vars: 5,
        consts: [["id", "myModal", "role", "dialog", 1, "modal", "fade"], [1, "modal-dialog", "modal-sm"], [1, "modal-content"], [1, "modal-header"], ["type", "button", "data-dismiss", "modal", 1, "close"], [1, "modal-title"], [1, "modal-body"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", 3, "click"]],
        template: function SessionTimerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "button", 4);
            i0.ɵɵtext(5, "\xD7");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "h4", 5);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "p");
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "div", 7)(12, "button", 8);
            i0.ɵɵlistener("click", function SessionTimerComponent_Template_button_click_12_listener() {
              return ctx.unsubscibeFromTimer();
            });
            i0.ɵɵtext(13);
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate(ctx.sessionTimerSitecoreContent.SessionTimerHeader || "your session is about to expire");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate3("", ctx.sessionTimerSitecoreContent.SessionTimerTextBeforeTimer || "your session is about to time out in", " ", ctx.timeLeftForSessionToExpireInput, ".", ctx.sessionTimerSitecoreContent.SessionTimerTextAfterTimer || "You will be asked to log in to Member Portal again after this time.", "");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", ctx.sessionTimerSitecoreContent.SessionTimerOkButtonText || "ok", " ");
          }
        }
      });
    }
  }
  return SessionTimerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WaitCursorComponent = /*#__PURE__*/(() => {
  class WaitCursorComponent {
    constructor() {
      this.show = true;
    }
    static {
      this.ɵfac = function WaitCursorComponent_Factory(t) {
        return new (t || WaitCursorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WaitCursorComponent,
        selectors: [["wait-cursor"]],
        inputs: {
          show: "show"
        },
        decls: 1,
        vars: 1,
        consts: [["class", "wait-cursor", 4, "ngIf"], [1, "wait-cursor"], [3, "blocked"], ["styleClass", "w-4rem h-4rem", "strokeWidth", "3", "fill", "var(--surface-ground)", "animationDuration", "2s"]],
        template: function WaitCursorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, WaitCursorComponent_div_0_Template, 3, 1, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.show);
          }
        },
        dependencies: [i1$1.NgIf, i2$1.BlockUI, i3$1.ProgressSpinner],
        styles: [".wait-cursor[_ngcontent-%COMP%]{z-index:2147483647}"]
      });
    }
  }
  return WaitCursorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
** Core module exposing all core views, services, and helpers
*/
let PortalUIComponentsModule = /*#__PURE__*/(() => {
  class PortalUIComponentsModule {
    constructor(applicationRef) {
      // for ng2-bootstrap-modal in angualar 5
      //Object.defineProperty(applicationRef, '_rootComponents', { get: () => applicationRef['components'] });
    }
    static {
      this.ɵfac = function PortalUIComponentsModule_Factory(t) {
        return new (t || PortalUIComponentsModule)(i0.ɵɵinject(i0.ApplicationRef));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PortalUIComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, BlockUIModule, ProgressSpinnerModule]
      });
    }
  }
  return PortalUIComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TokenInterceptor = /*#__PURE__*/(() => {
  class TokenInterceptor {
    constructor(injector, errorService) {
      this.injector = injector;
      this.errorService = errorService;
    }
    //authService :OAuthService;
    intercept(request, next) {
      let id = sessionStorage.getItem('identifier');
      if (!id) {
        id = '';
      }
      const authService = this.injector.get(OAuthService);
      const authHelper = this.injector.get(AuthHelper);
      if (authService.hasValidAccessToken() && authHelper.tokenNotExpired()) {
        const headers = {
          Authorization: `Bearer ${authService.getAccessToken()}`,
          identifier: id
        };
        request = request.clone({
          setHeaders: headers
        });
      } else if (id) {
        request = request.clone({
          setHeaders: {
            identifier: id
          }
        });
      }
      return next.handle(request).pipe(catchError(error => {
        // do Error mapping here
        return throwError(error);
      }));
    }
    static {
      this.ɵfac = function TokenInterceptor_Factory(t) {
        return new (t || TokenInterceptor)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i3.ErrorService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TokenInterceptor,
        factory: TokenInterceptor.ɵfac
      });
    }
  }
  return TokenInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CommaSeparatedNumberPipe, DateFormatPipe, EmailComponent, EmailValidationMessages, EmailViewProperties, FormatAddressPipe, PhoneMaskDirective, PhonePipe, PortalUIComponentsModule, SafePipe, SessionTimerComponent, TokenInterceptor, TruncatePipe, UIConfig, UppercaseInputDirective, WaitCursorComponent, ZipCodeMaskDirective, ZipCodePipe };
